export enum eTarget {
    Blank = '_blank',
    Self = '_self'
}